<template>
  <md-card>
    <md-card-content>
      <div :class="'md-layout'">
        <div :class="'md-layout-item md-size-100'">
          <span :class="'md-body-2'">Partner: <span :class="'md-body-1'">{{ q.engagement_leader ? q.engagement_leader.name : '' }}</span></span>
        </div>
        <div :class="'md-layout-item md-size-100'">
          <span :class="'md-body-2'">Director: <span :class="'md-body-1'">{{ q.director ? q.director.name : '' }}</span></span>
        </div>
        <div :class="'md-layout-item md-size-100'">
          <span :class="'md-body-2'">Manager of the Engagement: <span :class="'md-body-1'">{{ q.manager_engagement ? q.manager_engagement.name : '' }}</span></span>
        </div>
        <div :class="'md-layout-item md-size-100'">
          <span :class="'md-body-2'">RQR Reviewer: <span :class="'md-body-1'">{{ q.rqr_reviewer ? q.rqr_reviewer.name : '' }}</span></span>
        </div>
        <div :class="'md-layout-item md-size-100'">
          <span :class="'md-body-2'">Review Code: <span :class="'md-body-1'">{{ q.review_code }}</span></span>
        </div>
        <div :class="'md-layout-item md-size-100'">
          <span :class="'md-body-2'">RQR Type: <span :class="'md-body-1'">{{ q.advisory.rqr_type | rqrType }}</span></span>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
  import { rqrType } from '@/filters'

  export default {
    props: {
      q: {
        type: Object,
        default: () => {},
      }
    },

    filters: {
      rqrType,
    },
  }
</script>
